/**
 * Secure Configuration Service
 * Provides API keys and configuration without exposing them globally
 */
class ConfigService {
  constructor() {
    this.config = {};
    this.initialized = false;
  }

  /**
   * Initialize configuration from meta tags or data attributes
   */
  initialize() {
    if (this.initialized) return;

    // Get config from meta tags (more secure than window globals)
    const stripeKey = document.querySelector('meta[name="stripe-publishable-key"]')?.content;
    const froalaKey = document.querySelector('meta[name="froala-editor-key"]')?.content;
    const linkpreviewHost = document.querySelector('meta[name="linkpreview-host"]')?.content;
    const linkpreviewKey = document.querySelector('meta[name="linkpreview-key"]')?.content;
    const tenorApiKey = document.querySelector('meta[name="tenor-api-key"]')?.content;

    this.config = {
      stripe: {
        publishableKey: stripeKey
      },
      froala: {
        key: froalaKey
      },
      linkpreview: {
        host: linkpreviewHost,
        key: linkpreviewKey
      },
      tenor: {
        apiKey: tenorApiKey
      }
    };

    this.initialized = true;
  }

  /**
   * Get Stripe configuration
   */
  getStripeConfig() {
    this.initialize();
    return this.config.stripe;
  }

  /**
   * Get Froala editor configuration
   */
  getFroalaConfig() {
    this.initialize();
    return this.config.froala;
  }

  /**
   * Get Linkpreview configuration
   */
  getLinkpreviewConfig() {
    this.initialize();
    return this.config.linkpreview;
  }

  /**
   * Get Tenor API configuration
   */
  getTenorConfig() {
    this.initialize();
    return this.config.tenor;
  }

  /**
   * Get all configuration (for debugging - use sparingly)
   */
  getAllConfig() {
    this.initialize();
    return { ...this.config };
  }
}

// Export singleton instance
const configService = new ConfigService();
export default configService;
